import { PageWrapper } from '@/shared'
import { type IPriceDto, type INewAdminDto, type IFedOrderDto } from '@App/types/adminsTypes'

import { Actions } from './Actions/Actions'
import { AddAdminModal } from './AddAdminModal/AddAdminModal'
import style from './AdminControl.module.scss'
import { Data } from './Data/Data'

interface IProps {
    pageInfo: string | null
    showAddAdmin: boolean
    showUpdatePriceModal: boolean
    showUpdateOrderModal: boolean
    activateDates: string[] | null
    isFetchingAdmins: boolean
    setShowAddAdmin: (showAddAdmin: boolean) => void
    onAddAdminCallback: (dto: INewAdminDto) => void
    onUploadFileCallback: (dto: IPriceDto) => void
    onUploadOrderFileCallback: (dto: IFedOrderDto) => void
    setShowUpdatePriceModal: (showUpdatePriceModal: boolean) => void
    setShowUpdateOrderModal: (showUpdateOrderModal: boolean) => void
    onGetPriceActivateDates: () => void
    onGetPriceDataByDate: (date: string) => void
    onChangeDocument: (file: Blob, fileName: string, onSuccess: () => void) => void
}

export const AdminControl = (props: IProps) => {
    const {
        pageInfo,
        isFetchingAdmins,
        showAddAdmin,
        activateDates,
        showUpdatePriceModal,
        showUpdateOrderModal,
        onAddAdminCallback,
        setShowAddAdmin,
        onUploadFileCallback,
        onUploadOrderFileCallback,
        setShowUpdatePriceModal,
        setShowUpdateOrderModal,
        onGetPriceActivateDates,
        onGetPriceDataByDate,
        onChangeDocument
    } = props
    return (
        <PageWrapper>
            <div className={style.container}>
                {showAddAdmin && (
                    <AddAdminModal
                        show={showAddAdmin}
                        setShow={setShowAddAdmin}
                        onAddAdminCallback={onAddAdminCallback}
                    />
                )}
                <Actions
                    activateDates={activateDates}
                    showUpdatePriceModal={showUpdatePriceModal}
                    showUpdateOrderModal={showUpdateOrderModal}
                    isFetchingAdmins={isFetchingAdmins}
                    onGetPriceDataByDate={onGetPriceDataByDate}
                    onUploadFileCallback={onUploadFileCallback}
                    onUploadOrderFileCallback={onUploadOrderFileCallback}
                    setShowUpdatePriceModal={setShowUpdatePriceModal}
                    setShowUpdateOrderModal={setShowUpdateOrderModal}
                    onGetPriceActivateDates={onGetPriceActivateDates}
                    onChangeDocument={onChangeDocument}
                />
                <Data pageInfo={pageInfo} isFetchingAdmins={isFetchingAdmins} setShowAddAdmin={setShowAddAdmin} />
            </div>
        </PageWrapper>
    )
}
